/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancelsubscriptionconfirmtitle3Inputs */

const en_cancelsubscriptionconfirmtitle3 = /** @type {(inputs: Cancelsubscriptionconfirmtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel your subscription?`)
};

const de_cancelsubscriptionconfirmtitle3 = /** @type {(inputs: Cancelsubscriptionconfirmtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement kündigen?`)
};

/**
* | output |
* | --- |
* | "Cancel your subscription?" |
*
* @param {Cancelsubscriptionconfirmtitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cancelsubscriptionconfirmtitle3 = /** @type {((inputs?: Cancelsubscriptionconfirmtitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancelsubscriptionconfirmtitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cancelsubscriptionconfirmtitle3(inputs)
	return de_cancelsubscriptionconfirmtitle3(inputs)
});
export { cancelsubscriptionconfirmtitle3 as "cancelSubscriptionConfirmTitle" }